import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export function useFeatureFlag(name: string): boolean {
  const { data } = useQuery({
    queryKey: ['feature-flag', name],
    queryFn: async () => {
      const res = await apiClient.get(`/feature-flags/${name}`);
      return res.data.enabled as boolean;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  return data ?? false;
}
